<template>
  <div>

    <div class="apply-content apply-title">
      <div class="apply-title-desc">
        当前可提现
      </div>
      <div class="apply-title-money">
        {{price}}<span>元</span>
      </div>
    </div>

    <div class="apply-content apply-info">
      <div class="apply-info-desc">已绑定账户</div>
      <div class="apply-info-value">{{phone}}</div>
    </div>

    <div class="apply-content apply-money">
      <button :class="[moneyNum==1?'apply-money-choice':'apply-money-noChoice']" @click="choiceMoney(1)">100元</button>
      <button :class="[moneyNum==2?'apply-money-choice':'apply-money-noChoice']" @click="choiceMoney(2)">200元</button>
      <button :class="[moneyNum==3?'apply-money-choice':'apply-money-noChoice']" @click="choiceMoney(3)">500元</button>
      <button :class="[moneyNum==4?'apply-money-choice':'apply-money-noChoice']" @click="choiceMoney(4)">800元</button>
      <button :class="[moneyNum==5?'apply-money-choice':'apply-money-noChoice']" @click="choiceMoney(5)">1000元</button>
      <div class="apply-money-text">
        <div class="apply-money-text-title">
          其他金额
        </div>
        <div class="apply-money-text-input">
          <input type="number" placeholder="请输入金额" v-model="inputPrice" @focus="getFocus()" @keyup="getPrice()" @blur="checkPrice()"/>
        </div>
      </div>
    </div>

    <div class="apply-content apply-base">
      <div class="apply-base-each">
        <div class="apply-base-each-left">
          提现手机号
        </div>
        <div class="apply-base-each-middle">
          {{phone}}
        </div>
      </div>
      <div class="apply-base-each">
        <div class="apply-base-each-left">
          验证码
        </div>
        <div class="apply-base-each-middle">
          <input type="tel" style="height: 1.25rem;line-height: 1.25rem;margin: 0" v-model="captcha"/>
        </div>
        <div class="apply-base-each-right" @click="getCode()">
          <button>{{buttonText}}</button>distributionWithdraw
        </div>
      </div>
    </div>

    <!--<div class="apply-rule">-->
      <!--提现说明：最小提现金额¥100.00，提现自动转账至绑定的微信钱包，金额高于¥1000.00需要人工审核-->
    <!--</div>-->

    <div class="apply-button" @click="submit()">
      <button>
        提交
      </button>
    </div>


  </div>
</template>

<script>
  import Vue from 'vue'
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { getProductReviews,partyGetSendCaptcha,getWithdrawApply} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import {setStore,getStore} from "../../../utils/mUtil";

  export default {
    name: "distributionApply",
    data(){
      return{
        showLoading:true,
        moneyNum:1,
        buttonText:'获取验证码',
        count: '',
        timer: null,
        phone:this.$route.query.phone,
        price:this.$route.query.price,
        token:getStore('externalLoginKey'),
        captchaUuid:'',
        captcha:'',
        summitPrice:100,
        inputPrice:''
      }
    },

    mounted(){
      this.showLoading = false;
    },
    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      loading,
    },

    methods:{

      choiceMoney:function (money) {
        this.inputPrice = ''

        if(money==1){
          if(this.price<100){
            //Toast({message:'您当前可提现金额不足'})
          }else{
            this.moneyNum = 1
            this.summitPrice = 100
          }
        }else if(money == 2){
          if(this.price<100){
            Toast({message:'您当前可提现金额不足'})
          }else{
            this.moneyNum = 2
            this.summitPrice = 200
          }
        }else if(money == 3){
          if(this.price<500){
            Toast({message:'您当前可提现金额不足'})
          }else{
            this.moneyNum = 3
            this.summitPrice = 500
          }
        }else if(money == 4){
          if(this.price<800){
            Toast({message:'您当前可提现金额不足'})
          }else{
            this.moneyNum = 4
            this.summitPrice = 800
          }
        }else if(money == 5){
          if(this.price<1000){
            Toast({message:'您当前可提现金额不足'})
          }else{
            this.moneyNum = 5
            this.summitPrice = 1000
          }
        }else{
          this.moneyNum = 1
          this.summitPrice = 1000
        }
      },

      //点击验证后倒计时
      getCode(){
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.getValide()
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
              this.buttonText = this.count + "秒"
            }else {
              clearInterval(this.timer);
              this.timer = null;
              this.buttonText = '获取验证码'
            }
          }, 1000)

        }
      },

      // 获取验证码
      getValide:function () {
        let param = {
          externalLoginKey: this.token,
          mobileNumber:this.phone,
          amount:this.summitPrice,
        }
        partyGetSendCaptcha(param)
          .then(res => {
            console.log(res);
            if(!res._ERROR_MESSAGE_){
              //成功
              this.captchaUuid = res.captchaUuid
            }else{
              Toast({message:res._ERROR_MESSAGE_})
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      // 用户输入金额时
      getFocus:function(){
        this.moneyNum = ''
      },

      // 获取输入提现金额
      getPrice:function(){
        if(this.inputPrice == 100){
          this.summitPrice = 100
          this.moneyNum = 1
        }else if(this.inputPrice == 200){
          this.summitPrice = 200
          this.moneyNum = 2
        }else if(this.inputPrice == 500){
          this.summitPrice = 500
          this.moneyNum = 3
        }else if(this.inputPrice == 800){
          this.summitPrice = 800
          this.moneyNum = 4
        }else if(this.inputPrice == 1000){
          this.summitPrice = 1000
          this.moneyNum = 5
        }else{
          this.summitPrice = this.inputPrice
          this.moneyNum = ''
        }
      },

      //检查价格
      checkPrice:function(){
        if(this.summitPrice>this.price){
          Toast({message:'输入金额大于可提现金额'})
        }else{
          if(this.summitPrice==''){
            Toast({message:'提现金额必须大于0'})
          }
          // if(this.summitPrice<100&&this.summitPrice!=''){
          //   Toast({message:'提现金额必须大于100'})
          // }
        }
      },

      // 点击提交按钮
      submit:function () {
        if(this.summitPrice==''){
          Toast({message:'请选择提现金额'})
        }else{
          let param = {
            externalLoginKey: this.token,
            captchaUuid :this.captchaUuid,
            account:this.summitPrice,
            captcha:this.captcha,
            mobileNumber:this.phone
          }
          getWithdrawApply(param)
            .then(res => {
              console.log(res);
              if(!res._ERROR_MESSAGE_){
                //成功
                Toast({message:'提交申请成功'})
                this.$router.back(-1)
              }else{
                Toast({message:res._ERROR_MESSAGE_})
              }
            })
            .catch(err => {
              console.log(err);
            });
        }

      }

    }
  }
</script>

<style scoped>
  .apply-content{
    width:21.4375rem;
    margin: 1rem auto;
    box-shadow: 0 0 0.625rem #eee;
    border-radius: 0.5rem;
  }
  .apply-title{
    /*padding-top: 3rem;*/
    height: 5rem;
  }
  .apply-info{
    margin-top: 0.625rem;
    height: 2.8125rem;
  }
  .apply-money{
    margin-top: 0.625rem;
    height: 10.90625rem;
  }
  .apply-title-desc{
    width:100%;
    text-align: center;
    color:#333;
    font-size: 0.875rem;
    margin-top: 1rem;
    height: 2rem;
    line-height: 2rem;
  }
  .apply-title-money{
    text-align: center;
    width:100%;
    font-size:1.875rem;
    color:#D8598E;
    font-weight: bold;
  }
  .apply-title-money span{
    font-size: 0.6875rem;
  }
  .apply-info div{
    color:#333333;
    font-size: 0.8125rem;
    height: 2.8125rem;
    line-height: 2.8125rem;
  }
  .apply-info-desc{
    float: left;
    padding-left:0.5rem;
  }
  .apply-info-value{
    float: right;
    padding-right: 0.5rem;
  }
  .apply-money button{
    width:5.625rem;
    height: 2.8125rem;
    padding: 0;
    line-height: 2.8125rem;
    text-align: center;
    display: inline-block;
    vertical-align: top;
    font-size: 0.75rem;
    border-radius: 0.5rem;
    margin-top: 1rem;
    margin-left: 1rem;
  }
  .apply-money-choice{
    background: #D8598E;
    color:white;
  }
  .apply-money-noChoice{
    background: #eee;
    color: #333;
  }
  .apply-money-text{
    width:100%;
    margin-top:1rem;
    height: 1.5625rem;
    line-height: 1.5625rem;
  }
  .apply-money-text-title{
    font-size: 0.8125rem;
    color:#333;
    width:3.5rem;
    display: inline-block;
    vertical-align: top;
    margin-left: 1rem;
  }
  .apply-money-text-input{
    width:15.5rem;
    height: 1.5625rem;
    display: inline-block;
    vertical-align: top;

  }
  .apply-money-text-input input{
    width:15rem;
    height: 100%;
    border: 1px solid #EEEEEE;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    padding-left: 0.5rem;
    -webkit-appearance:none;
  }
  .apply-base{
    height: 5.5rem;
  }
  .apply-base-each{
    width:100%;
    height: 2.7rem;
    line-height: 2.7rem;
  }
  .apply-base-each div{
    display: inline-block;
    vertical-align: top;
    font-size: 0.8125rem;
    color:#333;
  }
  .apply-base-each-left{
    margin-left: 1rem;
    width:4.375rem;
  }
  .apply-base-each-middle{
    width:5.5rem;
    margin-left: 0.5rem;
  }
  .apply-base-each-middle input{
    border: 1px solid #EEEEEE;
    border-radius: 0.25rem;
    width:100%;
    height: 1.25rem;
    -webkit-appearance:none;
  }
  .apply-base-each-right{
    width:5.3125rem;
    margin-left: 3rem;
  }
  .apply-base-each-right button{
    width:100%;
    height: 100%;
    border: 1px solid #eee;
    color:#999;
    font-size: 0.8125rem;
    text-align: center;
    line-height:1.5625rem;
    padding: 0;
    border-radius: 0.25rem;
  }


  .apply-rule{
    width:21.4375rem;
    margin:0.625rem auto;
    color:#999;
    font-size: 0.75rem;
    line-height: 1.25rem;
  }
  .apply-button{
    width:19.375rem;
    margin: 3rem auto 1rem;
    height: 2.75rem;
  }
  .apply-button button{
    padding: 0;
    width:100%;
    height: 100%;
    line-height: 2.75rem;
    text-align: center;
    color:white;
    background-color: #EB84AB;
    border-radius: 1.375rem;
  }




</style>



// WEBPACK FOOTER //
// src/components/page/mine/distributionApply.vue